import axios from "axios";
import { system_api } from "../../service/system";

const instance = axios.create({
  // 路徑前綴
  baseURL: process.env.REACT_APP_ROOT_URL,
  headers: {
    "Content-Type": "application/json",
  },
  // 超時設定
  timeout: system_api.timeout,
});

instance.interceptors.request.use((config) => {
  return config;
});

// axios 回傳 response 以前
instance.interceptors.response.use(
  (result) => {
    /* 
      status: http status
      data: 回傳資料
    */
    const { status } = result;

    if (status >= 200 && status <= 299) {
      return result;
    } else {
      // api 有回應，但未成功取得資料
      const error = new Error(`Request failed with status ${status}`);
      error.response = result;
      return Promise.reject(error);
    }
  },
  (err) => {
    // api 呼叫錯誤
    return Promise.reject(err);
  }
);

export default instance;
